import { render, staticRenderFns } from "./SignInCallback.vue?vue&type=template&id=ed12d77a"
import script from "./SignInCallback.vue?vue&type=script&lang=js"
export * from "./SignInCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports